import Alpine from "alpinejs";

/**
 * This sets up the Alpine data store for managing self assessment modal states
 */
Alpine.store('self_assessment_modal', {
    init() {
        // @todo: may be unnecessary, but limiting it to 14 days for now
        const limitDismissDays = 14;
        const selfAssessmentSurveyDismissed = parseInt(localStorage.getItem('self_assessment_modal'))
        if (!isNaN(selfAssessmentSurveyDismissed)) {
            const secondsSinceDismissed = (Date.now().valueOf() / 1000) - selfAssessmentSurveyDismissed;
            const limitDismissSeconds = limitDismissDays * 24 * 60 * 60;
            if (limitDismissSeconds > secondsSinceDismissed) {
                this.state.dismissed = true;
            }
        }

    },

    state: {
        // Show the content of the self assessment modal
        showModal: false,
        // self assessment modal has been dismissed
        dismissed: false,
        // Custom HTML Dropdown: Gender
        genderLabel: 'Gender',
        // Custom HTML Dropdown: Assessment Type
        typeLabel: 'I\'m assessing...',
    },

    /**
     * Modal Methods.
     */

    dismiss() {
        this.state.dismissed = true;
        this.state.showModal = false;
        localStorage.setItem('self_assessment_modal', Math.floor(Date.now().valueOf() / 1000).toString());
    },

    hideModal() {
        this.state.showModal = false;
    },

    showModal() {
        this.state.showModal = true;
    },

    /**
     * Custom Dropdown Methods.
     */

    genderSelected( labelText ) {
        this.state.genderLabel = labelText;

        const genderSelectElement = document.querySelector('#mce-GENDER');
        Array.from(genderSelectElement.options).forEach(option => {
            if (option.text.trim() === labelText.trim()) {
                option.selected = true;
            }
            else {
                option.selected = false;
            }

        });
    },

    typeSelected( labelText ) {
        this.state.typeLabel = labelText;

        const genderSelectElement = document.querySelector('#TYPE');
        Array.from(genderSelectElement.options).forEach(option => {
            if (option.text.trim() === labelText.trim()) {
                option.selected = true;
            }
            else {
                option.selected = false;
            }

        });
    }

});
